<template>
    <div>
        <el-row>
            <el-col :span="12" :offset="6" style="margin-top:20vh;">
                <el-card>
                    <el-empty description="来到了一个不存在的地方哦">
                        <el-button type="primary" @click="back()">返回</el-button>
                    </el-empty>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
  
<script>

export default {
    name: "noZone",
    mounted() {

    },
    data() {
        return {

        }
    },
    props: {
        defaultMsg: {
            type: String
        },
        config: {
            type: Object
        }
    },
    created() {

    },

    methods: {
        back() {
            this.$router.push('/Login');
        }
    },

}
</script>
  
<style scoped lang="scss">
::-webkit-scrollbar {
    display: none;
}
</style>
  